import cloneDeep from 'lodash/cloneDeep'

const updateOrderVariants = (currentItems, updated) => {
  // First of all, we need to check if user
  // removed all variants from the cart,
  // and we need to reset saved list.

  if (!updated || !updated.length) {
    return []
  }

  let current = cloneDeep(currentItems)

  // Otherwise, iterate through the each variant of
  // the order, update already existed variants,
  // create new or remove dropped variants.

  let currentVariants = []
  const currentlyHasVariants = current && current.length > 0

  if (currentlyHasVariants) {
    currentVariants = current.map(ov => ov.uuid)
  }

  const actualVariantIds = updated.map(ov => ov.uuid)
  const createdVariantIds = updated
    .filter(ov => currentVariants.indexOf(ov.uuid) === -1)
    .map(ov => ov.uuid)

  if (currentlyHasVariants) {
    current = current.filter(ov => actualVariantIds.indexOf(ov.uuid) !== -1)
  }

  if (createdVariantIds.length > 0) {
    current = current || []

    updated.filter(ov => createdVariantIds.indexOf(ov.uuid) !== -1)
      .forEach(ov => current.push(ov))
  }

  const fields = [
    'quantity', 'has_measured_quantity', 'measured_quantity',
    'original_total_price', 'total_price', 'total_price_formatted',
    'discount_difference', 'has_discount',
  ]

  updated.forEach(ov => {
    const index = current.findIndex(v => v.uuid === ov.uuid)

    if (index === -1) {
      return
    }

    fields.forEach(f => current[index][f] = ov[f])
  })

  return current
}

const updateOrderData = (order, data) => {
  order.total_price = cloneDeep(data.total_price)
  order.original_total_price = cloneDeep(data.original_total_price)
  order.discount_difference = cloneDeep(data.discount_difference)
  order.has_discount = data.has_discount === true
  order.variants = updateOrderVariants(order.variants, data.variants)

  return order
}

export {
  updateOrderData,
}
